import { Injectable } from '@angular/core';
import { ApiBase } from '@apis/cas';
import { FileMeta, FileMetaCollection } from '@apis/cas/generated';
import { IFileMetaProvider } from '@core/lp/IFileMetaProvider';
import { lastValueFrom, Observable, Subject } from 'rxjs';
@Injectable({ providedIn: 'root' })
export class FileEndpoints extends ApiBase implements IFileMetaProvider {
  private fileUploaded = new Subject<FileMeta>();
  readonly fileUploaded$ = this.fileUploaded.asObservable();

  public getAllFileMetas(): Observable<FileMetaCollection> {
    return this.get<FileMetaCollection>(`/game/${this.gameId}/media/${this.dataPackage}`);
  }

  public getFileMeta(fileUid: string): Observable<FileMeta> {
    return this.get<FileMeta>(`/game/${this.gameId}/media/${this.dataPackage}/${fileUid}`);
  }

  public deleteFile(fileUid: string, force: boolean = false): Observable<void> {
    return this.delete<void>(`/game/${this.gameId}/media/${this.dataPackage}/${fileUid}`, {
      params: force ? { force: 'true' } : undefined,
    });
  }

  public downloadFile(fileUid: string): Observable<Blob> {
    return this.get(`/game/${this.gameId}/media/${this.dataPackage}/${fileUid}/download`, { responseType: 'blob' });
  }

  public updateFileMeta(fileUid: string, newFileMeta: FormData): Observable<FileMeta> {
    return this.put<FileMeta>(`/game/${this.gameId}/media/${this.dataPackage}/${fileUid}`, newFileMeta);
  }

  public async uploadFile(newFileMeta: FormData): Promise<FileMeta> {
    const fileMeta = await lastValueFrom(this.post<FileMeta>(`/game/${this.gameId}/media/${this.dataPackage}`, newFileMeta));
    this.fileUploaded.next(fileMeta);
    return fileMeta;
  }
}
